import React, { Component } from "react";
import BarLoader from 'react-spinners/BarLoader';

class Loader extends Component {

    render(){
        return(<div>{this.props.active ?
            <div className="rel full">
                <div className="above-center">
                    <h4 className="text-center">{this.props.text}</h4>
                </div>
                <div className="real-center">
                    <BarLoader
                        width={350}
                        size={100}
                        height={5}
                        sizeUnit={'px'}
                        color={'#f47b20'}
                    />
                </div>
            </div> : null}
        </div>
        )
    }
}

export default Loader;